module.exports = __webpack_public_path__ + "img/thepaymentoption-logo-white.2e30382e.svg";